module.exports = __webpack_public_path__ + "img/p1-pic@2x.259aef40.jpg";